import React, { useState, useEffect } from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { Link } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import { getProgress, getRafflesWithAvailability, verifyTicketByRifa } from "services/ticketService";
import { sendPurchaseConfirmation } from 'services/emailService';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import ModalTerms from "components/ModalTerms";
import PurchaseModal from "components/PurchaseModal";
import { useTheme, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Helmet } from "react-helmet";

export default function HomePage() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [prizes, setPrizes] = useState([]);
  const [loadingPrizes, setLoadingPrizes] = useState(true);
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [selectedRifa, setSelectedRifa] = useState(null);
  const [cedula, setCedula] = useState("");
  const [verificationResult, setVerificationResult] = useState(null);
  const [verifying, setVerifying] = useState(false);
  // Función para refrescar datos de progres y rifas
  const refreshData = () => {
    // Refrescar progreso
    setLoading(true);
    getProgress()
      .then(data => setProgress(data.percent))
      .catch(error => { if (error?.status === 404) setProgress(0); })
      .finally(() => setLoading(false));
    // Refrescar rifas
    setLoadingPrizes(true);
    getRafflesWithAvailability()
      .then(data => {
        // console.log("Raffles Data:", data); // Log the raffles data
        setPrizes(data);
      })
      .catch((error) => {
        console.error("Error fetching raffles:", error); // Log any errors
      })
      .finally(() => setLoadingPrizes(false));
  };
  const [termsOpen, setTermsOpen] = useState(false);
  const [termsLink, setTermsLink] = useState("");
  // Purchase modal state
  const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);
  const [selectedPrize, setSelectedPrize] = useState(null);

  const openTerms = (link) => {
    setTermsLink(link);
    setTermsOpen(true);
  };
  const closeTerms = () => setTermsOpen(false);
  const acceptTerms = () => {
    if (termsLink) window.open(termsLink, "_blank");
    setTermsOpen(false);
  };
  const openPurchaseModal = (prize) => {
    setSelectedPrize(prize);
    setPurchaseModalOpen(true);
  };
  const closePurchaseModal = () => {
    setPurchaseModalOpen(false);
    setSelectedPrize(null);
    refreshData();
  };

  const openVerifyModal = (prize) => {
    setSelectedRifa(prize);
    setVerifyModalOpen(true);
    setCedula("");
    setVerificationResult(null);
  };

  const closeVerifyModal = () => {
    setVerifyModalOpen(false);
    setSelectedRifa(null);
    setCedula("");
    setVerificationResult(null);
  };

  const handleVerify = async () => {
    if (!cedula || !selectedRifa) return;
    
    setVerifying(true);
    try {
      const result = await verifyTicketByRifa(cedula, selectedRifa.id);
      setVerificationResult(result);
    } catch (error) {
      setVerificationResult({
        found: false,
        message: "Error al verificar el ticket: " + error.message
      });
    } finally {
      setVerifying(false);
    }
  };


  useEffect(() => {
    getProgress()
      .then((data) => setProgress(data.percent))
      .catch((error) => {
        if (error?.status === 404) setProgress(0);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    getRafflesWithAvailability()
      .then((data) => {
        // console.log("Raffles Data:", data); // Log the raffles data
        setPrizes(data);
      })
      .catch((error) => {
        console.error("Error fetching raffles:", error); // Log any errors
      })
      .finally(() => setLoadingPrizes(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>GANA CON BENDICION EN MANOS - Rifas Legales en Venezuela</title>
        <meta name="description" content="Participa en las mejores rifas legales de Venezuela. Premios garantizados, sorteos transparentes y tickets verificables. ¡Compra tus tickets ahora!" />
        <meta name="keywords" content="rifas Venezuela, rifas legales, sorteos Venezuela, premios garantizados, tickets verificables, rifas online, compra de tickets, sorteos legales" />
        <meta property="og:title" content="GANA CON BENDICION EN MANOS - Rifas Legales en Venezuela" />
        <meta property="og:description" content="Participa en las mejores rifas legales de Venezuela. Premios garantizados, sorteos transparentes y tickets verificables." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ganaconbendicionenmanos.com" />
        <meta property="og:image" content="https://ganaconbendicionenmanos.com/assets/images/banner-desktop.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="GANA CON BENDICION EN MANOS - Rifas Legales en Venezuela" />
        <meta name="twitter:description" content="Participa en las mejores rifas legales de Venezuela. Premios garantizados, sorteos transparentes y tickets verificables." />
        <meta name="twitter:image" content="https://ganaconbendicionenmanos.com/assets/images/banner-desktop.png" />
        <link rel="canonical" href="https://ganaconbendicionenmanos.com" />
      </Helmet>

      {/* Main Banner Image */}
      <MKBox
        component="img"
        src={isDesktop ? "assets/images/banner-desktop.png" : "assets/images/banner.png"}
        alt="GANA CON BENDICION EN MANOS - Las mejores rifas legales de Venezuela"
        width="100%"
        sx={{ mb: 4, maxHeight: "85vh", objectFit: "cover", with: "auto" }}
      />

      {/* Prize Cards */}
      <MKBox px={2} py={2} display="flex" justifyContent="center" alignItems="center">
        {loadingPrizes ? (
          <CircularProgress />
        ) : (
          <Grid container spacing={4} justifyContent="center">
            {prizes.map((prize) => (
              <Grid item xs={12} md={4} key={prize.id}>
                <Card>
                  <CardMedia
                    component="img"
                    src={prize.imageUrl || prize.image}
                    alt={`Rifa ${prize.title} - Premio garantizado`}
                    sx={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "none",
                      objectFit: "contain",
                    }}
                  />
                  <CardContent sx={{ textAlign: "center" }}>
                    <Box sx={{ position: "relative", width: "100%", marginTop: 2 }}>
                      <LinearProgress
                        variant="determinate"
                        value={prize.percentAvailable}
                        sx={{
                          width: "100%",
                          height: 24,
                          borderRadius: 12,
                          backgroundColor: theme.palette.grey[300],
                          "& .MuiLinearProgress-bar": {
                            height: "auto",
                            borderRadius: 12,
                            backgroundColor: theme.palette.grey[600],
                            backgroundImage:
                              "linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
                              // key change: limit gradient to percent width
                              backgroundSize: `${prize.percentAvailable}% 100%`,
                              backgroundRepeat: "no-repeat",
                              transition: "background-size 0.5s ease",
                          },
                        }}
                      />
                      <MKTypography
                        variant="body2"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          color: "#fff",
                          fontWeight: "bold",
                          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        {prize.percentAvailable.toFixed(2)}% Disponible
                      </MKTypography>
                    </Box>
                  </CardContent>
                  <CardActions
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {prize.ticketsCount > 0 ? (
                      <MKButton
                        variant="contained"
                        onClick={() => openPurchaseModal(prize)}
                        sx={{
                          mr: 1,
                          background:
                            "linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
                          color: "#fff",
                          textShadow: "0px 1px 2px rgba(0,0,0,0.5)",
                          borderRadius: "0.5rem",
                          "&:hover": {
                            filter: "brightness(1.1)",
                          },
                        }}
                      >
                        COMPRAR TICKET
                      </MKButton>
                    ) : (
                      <MKTypography variant="body2" color="error" sx={{}}>
                      </MKTypography>
                    )}
                    <MKButton
                      variant="outlined"
                      onClick={() => openVerifyModal(prize)}
                      sx={{
                        my: 1,
                        borderRadius: "0.5rem",
                        border: "2px solid transparent",
                        backgroundImage:
                          "linear-gradient(#fff, #fff), linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
                        backgroundOrigin: "padding-box, border-box",
                        backgroundClip: "padding-box, border-box",
                        color: "text.secondary",
                        "&:hover, &:focus": {
                          filter: "brightness(1.1)",
                          borderRadius: "0.5rem",
                          border: "2px solid transparent",
                          backgroundImage:
                            "linear-gradient(#fff, #fff), linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
                          backgroundOrigin: "padding-box, border-box",
                          backgroundClip: "padding-box, border-box",
                          color: "text.secondary",
                        },
                      }}
                    >
                      VERIFICAR TICKET
                    </MKButton>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </MKBox>

      {/* Support Section */}
      <MKBox py={4} textAlign="center">
        <MKButton
          variant="contained"
          color="success"
          component="a"
          href="https://whatsapp.com/channel/0029VbAGM9S002T5V4QWnj24 "
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<WhatsAppIcon />}
          sx={{
            mr: 2,
            backgroundColor: "rgba(37, 211, 102, 0.9)",
            "&:hover": {
              backgroundColor: "rgba(37, 211, 102, 1)",
              transform: "scale(1.05)",
            },
            transition: "all 0.3s ease",
            boxShadow: "0 0 10px rgba(37, 211, 102, 0.3)",
          }}
        >
          Canal WhatsApp
        </MKButton>
      </MKBox>

      {/* Purchase Modal */}
      <PurchaseModal open={purchaseModalOpen} onClose={closePurchaseModal} prize={selectedPrize} />

      {/* Terms Modal */}
      <ModalTerms open={termsOpen} onClose={closeTerms} onAccept={acceptTerms} />

      {/* Verify Ticket Modal */}
      <Dialog 
        open={verifyModalOpen} 
        onClose={closeVerifyModal} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '1rem',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          }
        }}
      >
        <DialogTitle sx={{ 
          textAlign: 'center',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          background: 'linear-gradient(90deg, rgba(131, 0, 149, 0.8) 0%, rgba(131, 0, 149, 0.8) 33%, rgba(131, 0, 149, 0.8) 66%, rgba(131, 0, 149, 0.8) 100%)',
          color: '#fff',
          textShadow: '0px 1px 2px rgba(0,0,0,0.5)',
          borderBottom: 'none',
          py: 3,
          px: 4,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '50%',
            height: '3px',
            background: 'rgba(255,255,255,0.3)',
            borderRadius: '3px'
          }
        }}>
          <IconButton
            onClick={closeVerifyModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box>
            <MKTypography variant="h4" fontWeight="bold" color="white" sx={{ textAlign: 'center', textShadow: '0px 1px 2px rgba(0,0,0,0.5)' }} >
              {selectedRifa?.title}
            </MKTypography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ 
              display: 'flex', 
              gap: 1,
              alignItems: 'center'
            }}>
              <TextField
                fullWidth
                label="Número de Cédula"
                value={cedula}
                onChange={(e) => setCedula(e.target.value)}
                disabled={verifying}
                sx={{ 
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '0.5rem',
                    '&:hover fieldset': {
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
              />
              <MKButton
                onClick={handleVerify}
                variant="contained"
                disabled={!cedula || verifying}
                sx={{
                  minWidth: '120px',
                  height: '44px',
                  background:
                    'linear-gradient(90deg, rgba(131, 0, 149, 0.8) 0%, rgba(131, 0, 149, 0.8) 33%, rgba(131, 0, 149, 0.8) 66%, rgba(131, 0, 149, 0.8) 100%)',
                  color: '#fff',
                  textShadow: '0px 1px 2px rgba(0,0,0,0.5)',
                  borderRadius: '0.5rem',
                  '&:hover': {
                    filter: 'brightness(1.1)',
                  },
                  '&.Mui-disabled': {
                    background: theme.palette.grey[300],
                    color: theme.palette.grey[500],
                  }
                }}
              >
                {verifying ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  <>
                    <SearchIcon sx={{ mr: 1 }} />
                    Buscar
                  </>
                )}
              </MKButton>
            </Box>
            {verificationResult && (
              <Box sx={{ mt: 2 }}>
                <MKTypography
                  variant="body1"
                  color={verificationResult.found ? "success.main" : "error.main"}
                  sx={{ 
                    mb: 1,
                    textAlign: 'center',
                    fontWeight: 'bold'
                  }}
                >
                  {verificationResult.message}
                </MKTypography>
                {verificationResult.found && verificationResult.purchases && (
                  <Box sx={{ mt: 2 }}>
                    <MKTypography 
                      variant="h6" 
                      gutterBottom
                      sx={{ 
                        textAlign: 'center',
                        color: theme.palette.primary.main,
                        fontWeight: 'bold'
                      }}
                    >
                      Tickets Encontrados:
                    </MKTypography>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      gap: 3,
                      mt: 2
                    }}>
                      {/* Tickets Pagados */}
                      {verificationResult.purchases.some(p => p.status === 'pagado') && (
                        <Box sx={{ 
                          border: `1px solid ${theme.palette.success.light}`,
                          borderRadius: '1rem',
                          p: 2,
                          backgroundColor: theme.palette.success.light + '10'
                        }}>
                          <MKTypography 
                            variant="subtitle1" 
                            sx={{ 
                              mb: 2,
                              color: theme.palette.success.main,
                              fontWeight: 'bold'
                            }}
                          >
                            Tickets Validados
                          </MKTypography>
                          <Box sx={{ 
                            display: 'flex', 
                            flexWrap: 'wrap', 
                            gap: 1,
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}>
                            {verificationResult.purchases
                              .filter(p => p.status === 'pagado')
                              .flatMap(p => p.tickets)
                              .map((ticket, index) => (
                                <MKTypography
                                  key={index}
                                  variant="body2"
                                  sx={{
                                    display: 'inline-block',
                                    backgroundColor: theme.palette.success.main,
                                    color: '#fff',
                                    padding: '6px 16px',
                                    borderRadius: '16px',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    '&:hover': {
                                      transform: 'scale(1.05)',
                                      transition: 'all 0.2s ease-in-out',
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                                    }
                                  }}
                                >
                                  #{String(ticket.numeroTicket).padStart(4, '0')}
                                </MKTypography>
                            ))}
                          </Box>
                        </Box>
                      )}

                      {/* Tickets Pendientes */}
                      {verificationResult.purchases
                        .filter(p => p.status === 'pendiente')
                        .map((purchase, index) => (
                          <Box key={index} sx={{ 
                            border: `1px solid ${theme.palette.warning.light}`,
                            borderRadius: '1rem',
                            p: 2,
                            backgroundColor: theme.palette.warning.light + '10'
                          }}>
                            <MKTypography 
                              variant="subtitle1" 
                              sx={{ 
                                mb: 1,
                                color: theme.palette.warning.main,
                                fontWeight: 'bold'
                              }}
                            >
                              Compra Pendiente #{index + 1}
                            </MKTypography>
                            <Box sx={{ mb: 2 }}>
                              <MKTypography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>Referencia:</strong> {purchase.referencia}
                              </MKTypography>
                              <MKTypography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>Monto:</strong> Bs. {purchase.totalAmount}
                              </MKTypography>
                            </Box>
                            <Box sx={{ 
                              display: 'flex', 
                              flexWrap: 'wrap', 
                              gap: 1,
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}>
                              {purchase.tickets.map((ticket, ticketIndex) => (
                                <MKTypography
                                  key={ticketIndex}
                                  variant="body2"
                                  sx={{
                                    display: 'inline-block',
                                    backgroundColor: theme.palette.warning.main,
                                    color: '#fff',
                                    padding: '6px 16px',
                                    borderRadius: '16px',
                                    fontWeight: 'bold',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    '&:hover': {
                                      transform: 'scale(1.05)',
                                      transition: 'all 0.2s ease-in-out',
                                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                                    }
                                  }}
                                >
                                  #{String(ticket.numeroTicket).padStart(4, '0')}
                                </MKTypography>
                              ))}
                            </Box>
                          </Box>
                        ))}
                    </Box>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ 
          p: 3,
          borderTop: `1px solid ${theme.palette.grey[200]}`,
          justifyContent: 'center',
          gap: 2,
          background: 'linear-gradient(90deg, rgba(33, 150, 243, 0.05) 0%, rgba(139, 195, 74, 0.05) 33%, rgba(255, 235, 59, 0.05) 66%, rgba(244, 67, 54, 0.05) 100%)',
        }}>
          <MKButton 
            onClick={closeVerifyModal} 
            variant="outlined"
            sx={{
              borderRadius: '0.5rem',
              border: '2px solid transparent',
              backgroundImage:
'linear-gradient(#fff, #fff), linear-gradient(90deg, rgba(131, 0, 149, 0.8) 0%, rgba(131, 0, 149, 0.8) 33%, rgba(131, 0, 149, 0.8) 66%, rgba(131, 0, 149, 0.8) 100%)',
              backgroundOrigin: 'padding-box, border-box',
              backgroundClip: 'padding-box, border-box',
              color: 'text.secondary',
              '&:hover': {
                filter: 'brightness(1.1)',
                borderRadius: '0.5rem',
                border: '2px solid transparent',
                backgroundImage:
                  'linear-gradient(#fff, #fff), linear-gradient(90deg, rgba(131, 0, 149, 0.8) 0%, rgba(131, 0, 149, 0.8) 33%, rgba(131, 0, 149, 0.8) 66%, rgba(131, 0, 149, 0.8) 100%)',
                backgroundOrigin: 'padding-box, border-box',
                backgroundClip: 'padding-box, border-box',
                color: 'text.secondary',
              },
            }}
          >
            Cerrar
          </MKButton>
        </DialogActions>
      </Dialog> 
    </>
  );
}
